function parse(data) {
    try {
        return JSON.parse(data);
    } catch (error) {
        return data;
    }
}

export default {
    keys: {
        ACCESS_TOKEN: "ACCESS_TOKEN",
        USER_INFO: "USER_INFO",
        SERVICE_NUMBER: "SERVICE_NUMBER",
    },
    get: (key, str2empty = true) => {
        const data = window.localStorage.getItem(key);
        if(str2empty && data === "undefined") {
            return undefined;
        }
        if(str2empty && data === "null") {
            return null;
        }
        return parse(data);
    },
    set: (key, value) => {
        let data = value;
        if (typeof value === "object") {
            data = JSON.stringify(value);
        }
        window.localStorage.setItem(key, data);
    },
    clear: () => {
        window.localStorage.clear();
    }
}
